
import { createContext } from 'react';
import { ThemeContextProps } from '../interfaces/app.interface';

/**
 * ThemeContext provides global theme state management (dark/light mode).
 * Contains theme state and dispatch function for theme updates.
 * 
 * @context
 * @example
 * ```tsx
 * const { state, dispatch } = useContext(ThemeContext);
 * 
 * dispatch({ field: 'isDarkTheme', value: true });
 * ```
 */
export const ThemeContext = createContext<ThemeContextProps>(undefined!);
